// Initial State Object Definition.
export default {
	currentUserData: null
}